import React from "react";
export const AspectItem = ({ title, content }) => (React.createElement("div", { className: "aspect-item-root" },
    title && React.createElement("p", { className: "aspect-item-root__title regular" }, title),
    React.createElement("div", { className: "aspect-item-root__description", dangerouslySetInnerHTML: {
            __html: content,
        } })));
